<script setup lang="ts">
import HeadingBloc from "@/views/booking/HeadingBloc.vue";
import BookingSearch from "@/views/booking/BookingSearch.vue";
import ApartmentItem from "@/views/booking/ApartmentItem.vue";
import CsaPagination from "@/components/CsaPagination.vue";
import {ref} from "vue";
import Room from "@/models/Room";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";

const roomPaginate =ref<Room[]>([]);
const load = ref(true)
const updatePagination = (event:any)=>{
  load.value = true;
  console.log(event.data);
  roomPaginate.value = event.data.value;
  setTimeout(()=>{
    load.value = false
  },1000)
}

</script>

<template>
  <heading-bloc></heading-bloc>
  <booking-search></booking-search>
  <div class="uk-padding  uk-padding-remove-horizontal">
    <div class="uk-padding">
      <LoadingSpinner v-if="load"></LoadingSpinner>

      <div class="uk-position-relative uk-visible-toggle uk-margin-small-top">
        <ul class="uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1@s data-uk-grid uk-grid-match uk-margin-large-bottom"
            data-uk-grid>
          <apartment-item v-for="(room,index) in roomPaginate" :key="index" :room-item="room"></apartment-item>
        </ul>
        <csa-pagination  :item-perp-page="3" @data-paginate="updatePagination($event)"></csa-pagination>
      </div>

    </div>
  </div>
</template>

<style scoped>

</style>